import { usePathname } from 'next/navigation';

import { useEffect } from 'react';

const SESSION_STORAGE_KEY = 'pathname-without-redirect-on-login';

export const isRedirectOnLoginDisabled = (pathname: string) => {
  const rawData = sessionStorage.getItem(SESSION_STORAGE_KEY);

  if (!rawData) {
    return false;
  }

  try {
    const data = JSON.parse(rawData);

    return typeof data === 'object' && pathname in data;
  } catch (error) {
    // DO NOTHING
  }

  return false;
};

const setPathnameWithDisabledRedirectOnLogin = (pathname: string) => {
  const rawData = sessionStorage.getItem(SESSION_STORAGE_KEY);

  let data: Record<string, any> = {};

  if (rawData) {
    try {
      const parsedData = JSON.parse(rawData);

      if (typeof data === 'object') {
        data = parsedData;
      }
    } catch (error) {
      // DO NOTHING
    }
  }

  sessionStorage.setItem(
    SESSION_STORAGE_KEY,
    JSON.stringify({
      ...data,
      [pathname]: true,
    }),
  );
};

/**
 * Sets special cookie in sessionStorage that prevents redirect to the profile page when user is new
 * (we redirect new users to the profile page so they can fill username)
 */
const useDisableRedirectOnLogin = () => {
  const pathname = usePathname();

  useEffect(() => {
    setPathnameWithDisabledRedirectOnLogin(pathname);
  }, [pathname]);
};

export default useDisableRedirectOnLogin;
